module.exports = __webpack_public_path__ + "media/images/spinner-horizontal-17f5888465c891603b7981eb08bfb6ae.gif";